export function AUTH_ACCESS_TOKEN() {
  return localStorage.getItem("accessToken");
}

export function AUTH_ID_TOKEN() {
  return localStorage.getItem("idToken");
}

export function AUTH_REFRESH_TOKEN() {
  return localStorage.getItem("refreshToken");
}

export function APP_FUNCTIONS() {
  return [
    "dashboard",
    "user",
    "handHygieneModule",
    "ppeModule",
    "patientModule",
    "narcoticsModule",
    "patientCareModule",
    "diningModule",
  ];
}

export const USERS_PER_PAGE = 10;
export const USER_PROFILE = "user-profile";
export const REFRESH_TOKEN = "refreshToken";
export const ID_TOKEN = "idToken";
export const ACCESS_TOKEN = "accessToken";
export const USER_GROUP = "userGroup";
export const THEME = "theme";
export const PPE_HISTORY = "ppeHistory";
export const HAND_HYGIENE_HISTORY = "handHygieneHistory";
export const MAX_DROPDOWN_HEIGHT = "500px";

export const GRAPH_COLORS = ["#57BF71", "#F6CE46", "#EE765E"];
